module.exports = __webpack_public_path__ + "static/media/Icon-PastTransfer.4ce229b1.png";